import ResponsiveOverlay from '@/components/ResponsiveOverlay';

export interface TripImportDiscardConfirmDialogProps {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

export function TripImportDiscardConfirmDialog({
  open,
  onKeepEditing,
  onDiscard,
}: TripImportDiscardConfirmDialogProps) {
  if (!open) return null;

  return (
    <ResponsiveOverlay
      onClose={onKeepEditing}
      presentation="dialog"
      className="trip-import-discard-overlay !z-[10070]"
      aria-label="Discard import confirmation"
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="trip-import-discard-title"
        aria-describedby="trip-import-discard-message"
        className="flex w-[min(100%,400px)] flex-col gap-5 rounded-[20px] bg-white p-6 font-manrope shadow-[0_0_20px_rgba(0,0,0,0.15)]"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex flex-col gap-2">
          <h2
            id="trip-import-discard-title"
            className="font-lora text-xl font-semibold tracking-[0.3px] text-[#252528]"
          >
            Discard import?
          </h2>
          <p id="trip-import-discard-message" className="text-sm leading-relaxed text-[#525257]">
            You&apos;ll lose this preview and any edits you made. This can&apos;t be undone.
          </p>
        </div>
        <div className="flex flex-col-reverse gap-2 min-[480px]:flex-row min-[480px]:justify-end">
          <button
            type="button"
            className="rounded-[20px] px-6 py-3 text-[15px] font-medium text-[#525257] hover:text-[#252528]"
            onClick={onKeepEditing}
          >
            Keep editing
          </button>
          <button
            type="button"
            className="rounded-[20px] bg-[#252528] px-6 py-3 text-[15px] font-bold text-white shadow-[0_0_10px_rgba(0,0,0,0.15)]"
            onClick={onDiscard}
          >
            Discard import
          </button>
        </div>
      </div>
    </ResponsiveOverlay>
  );
}
